import { supabase } from "@/integrations/supabase/client";

export type ContratoCadeia = {
  id: number;
  numero_contrato: string;
  pedido_id?: number | null;
  valor?: number | null;
  numero_ciclo?: number | null;
  status?: string | null;
};

/** Percorre pedido_anterior_id até achar o contrato da 1ª venda (mesmo número). */
export async function findContratoDaCadeiaPedido(
  pedidoId: number
): Promise<ContratoCadeia | null> {
  let current = pedidoId;
  const visitados = new Set<number>();

  for (let i = 0; i < 30; i++) {
    if (visitados.has(current)) break;
    visitados.add(current);

    const { data: contrato } = await supabase
      .from("contratos")
      .select("id, numero_contrato, pedido_id, valor, numero_ciclo, status")
      .eq("pedido_id", current)
      .order("id", { ascending: false })
      .limit(1)
      .maybeSingle();

    if (contrato?.id) {
      return contrato as ContratoCadeia;
    }

    const { data: pedido } = await supabase
      .from("pedidos")
      .select("pedido_anterior_id")
      .eq("id", current)
      .maybeSingle();

    if (!pedido?.pedido_anterior_id) return null;
    current = Number(pedido.pedido_anterior_id);
  }

  return null;
}
